module.exports = __webpack_public_path__ + "img/victoria_maraia_7.42f14204.jpg";